import { Button, Group, Stack, TextInput, NumberInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { type PayinAdminTraderV1ActivateTraderRequest } from '~/generated/payinBackend/model';
import { initialValues, transformValues, validate } from '../config';
import { ConfigEditor } from './ConfigEditor';

interface ActivationFormProps {
    onSubmit: (values: PayinAdminTraderV1ActivateTraderRequest) => void;
    traderId: string;
    isLoading?: boolean;
}

export const ActivationForm = ({ onSubmit, traderId, isLoading }: ActivationFormProps) => {
    const form = useForm<PayinAdminTraderV1ActivateTraderRequest>({
        initialValues: {
            traderId: {
                value: traderId,
            },
            traderName: {
                value: '',
            },
            ...initialValues,
        },
        transformValues,
        validate,
    });

    return (
        <form
            onSubmit={form.onSubmit((v) => {
                onSubmit(v);
                form.resetDirty();
            })}
        >
            <Stack>
                <TextInput
                    label='Имя трейдера'
                    placeholder='Введите имя'
                    {...form.getInputProps('traderName.value')}
                />
                <NumberInput
                    label='Комиссия'
                    placeholder='Введите число'
                    valueIsNumericString
                    min={0}
                    {...form.getInputProps('commission.value')}
                />

                <TextInput
                    label='Правила расчёта'
                    placeholder='Введите правила'
                    {...form.getInputProps('calculationRules')}
                />

                <ConfigEditor
                    form={form}
                    isLoading={isLoading}
                />

                <Group justify='space-between'>
                    <Button
                        fullWidth
                        type='submit'
                        disabled={isLoading}
                        loading={isLoading}
                    >
                        Активировать
                    </Button>
                </Group>
            </Stack>
        </form>
    );
};
